export default __webpack_public_path__ + "67e4d00e0eea3951cdbfdcf792075e21.png";